import React, { useEffect, useState } from "react";
import {
  getDownloadURL,
  ref,
  uploadBytesResumable,
  uploadBytes,
  deleteObject,
} from "@firebase/storage";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  increment,
} from "firebase/firestore";
import { db, functions } from "../../../Firebase";
import { httpsCallable } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { Timestamp } from "firebase/firestore";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import "./createQuiz.css";
import { ExpandMoreSharp } from "@mui/icons-material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { MdEdit, MdDelete } from "react-icons/md";
import { ExpandMoreSvg } from "./icons";
import DeleteLesson from "./lessonDeletePopUp";
import { IP } from "../../../config";
import axios from "axios";
import { getCookie } from "../../../Cookies";
const CreateCrossWordQuestion = ({
  quizId,
  questionData,
  editQuestion,
  setfetchDataFromApi,
  fetchDataFromApi,
  flagForSeconstEdit,
}) => {
  const storage = getStorage();

  const createQuestion = httpsCallable(functions, "createQuestion");
  const addQuestionSetOrder = httpsCallable(functions, "addQuestionSetOrder");
  //addQuestionSetOrder
  // added by Himanshu
  const [deleteQuestionId, setDeleteQuestionId] = useState("");
  const [openLessonPopUp, setopenLessonPopUp] = useState(false);

  const [questionName, setQuestionName] = useState("");
  const [questionId, setQuestionId] = useState("");

  const initialList = [];
  const [list, setList] = useState(initialList);

  const [trueFalse, setTrueFalse] = useState(false);

  const [fillUpsAns, setFillUpsAns] = useState("");
  // rearrange
  const [canEditRearrange, setCanEditRearrange] = useState(true);
  const [rearrangeOptions, setRearrangeOptions] = useState([
    {
      text: "First",
      position: 1,
    },
    {
      text: "Second",
      position: 2,
    },
    {
      text: "Third",
      position: 3,
    },
    {
      text: "Fourth",
      position: 4,
    },
  ]);
  /* arr element example
    {
      text:"rearrange",
      position: 1
    }
  */

  const [qusMode, setqusMode] = useState("");
  const [qustype, setqustype] = useState("8");
  const [qus, setqus] = useState("");
  const [qusInstruction, setqusInstruction] = useState("");
  const [PointorScore, setPointorScore] = useState("");
  const [qus5, setqus5] = useState({
    option1: "",
    option2: "",
    option3: "",
    option4: "",
    option5: "",
    option6: "",
  });

  const [checkErrorInForm, setCheckErrorInForm] = useState({
    option1: "",
    option2: "",
    option3: "",
    option4: "",
    option5: "",
    option6: "",
    questionName: "",
    qusInstruction: "",
    qus: "",
    qus5Answer: "",
  });
  const [qus5Answer, setqus5Answer] = useState("Option 1");
  const [qus2, setqus2] = useState({ word: "", correctImage: "" });
  const [formCheck, setFormCheck] = useState("");
  function submit(e) {
    e.preventDefault();
  }

  const scrambleArr = (arr) => {
    //console.log(arr[0]);
    let res = Array.from(arr);
    return res.sort((a, b) => 0.5 - Math.random());
  };

  const [canEditMatchPair, setCanEditMatchPair] = useState(true);
  const [leftOptions, setLeftOptions] = useState(new Array(4).fill(""));
  const [rightOptions, setRightOptions] = useState([
    {
      text: "",
      match: 1,
    },
    {
      text: "",
      match: 2,
    },
    {
      text: "",
      match: 3,
    },
    {
      text: "",
      match: 4,
    },
  ]);

  const handleMatchPair = (e, order, side) => {
    //console.log("onChange");
    if (!canEditMatchPair) return;
    if (side == "left") {
      setLeftOptions((prev) => {
        let item = e.target.value;

        let res = Array.from(prev);
        res[order - 1] = item;
        return res;
      });
    } else {
      setRightOptions((prev) => {
        let item = {
          text: e.target.value,
          match: order,
        };
        let res = Array.from(prev);
        res[order - 1] = item;
        return res;
      });
    }
  };

  const handleMatchUpScramble = () => {
    setCanEditMatchPair(false);
    setRightOptions((prev) => {
      let res = scrambleArr(prev);
      //console.log(res);
      return res;
    });
  };

  // match words to image

  useEffect(() => {
    console.log(questionData);
    //
    if (!editQuestion) return;
    setqus(questionData.data?.question);
    setQuestionName(questionData?.name);
    setQuestionId(questionData?.id);
    setqusInstruction(questionData.data?.questionInstruction);

    if (questionData.data.options) {
      let arr = {};
      setqus5(questionData.data.options);

      // for (let i = 0; i < questionData.data.options.length; i++) {
      //   let op = `option${i + 1}`;
      //   console.log(op);

      //   arr[op] = questionData.data.options[i].op;

      //   if (questionData.data.options[i].iscorrect) {
      //     setqus5Answer(`Option ${i + 1}`);
      //   }
      //   if (i == questionData.data.options.length - 1) {
      //     setqus5(arr);
      //   }
      // }
    }
  }, [flagForSeconstEdit]);

  const formCheckFunction = () => {
    if (questionName === "") {
      setCheckErrorInForm((prev) => ({ ...prev, questionName: "error" }));
      return "question Name";
    }

    if (qus === "") {
      setCheckErrorInForm((prev) => ({ ...prev, qus: "error" }));
      return "question ";
    }
    if (qusInstruction === "") {
      setCheckErrorInForm((prev) => ({ ...prev, qusInstruction: "error" }));
      return "question ";
    }

    const checkLength = (str) => {
      if (str?.length < 1 || str?.length > 8) {
        return true;
      } else {
        return false;
      }
    };
    if (checkLength(qus5.option1)) {
      setCheckErrorInForm((prev) => ({ ...prev, option1: "error" }));
      return "question option1";
    }
    if (checkLength(qus5.option2)) {
      setCheckErrorInForm((prev) => ({ ...prev, option2: "error" }));
      return "question option2";
    }
    if (checkLength(qus5.option3)) {
      setCheckErrorInForm((prev) => ({ ...prev, option3: "error" }));
      return "question option3";
    }
    if (checkLength(qus5.option4)) {
      setCheckErrorInForm((prev) => ({ ...prev, option4: "error" }));
      return "question option4";
    }
    if (checkLength(qus5.option5)) {
      setCheckErrorInForm((prev) => ({ ...prev, option5: "error" }));
      return "question option5";
    }
    if (checkLength(qus5.option6)) {
      setCheckErrorInForm((prev) => ({ ...prev, option5: "error" }));
      return "question option6";
    }

    return "alliswell";
  };

  async function saveOrder(items) {
    var orderList = [];
    for (let i = 0; i < items.length; i++) {
      orderList.push(items[i].id);
    }
    let configCreateExtraInfo = {
      method: "patch",
      // params: { questionSetId: quizId },
      url: `${IP}/courseBuilder/questionSet`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: JSON.stringify({
        questionSetId: quizId,
        questions: orderList,
        edit: true,
      }),
    };
    await axios(configCreateExtraInfo);

    // addQuestionSetOrder({
    //   questionSetId: quizId,
    //   questions: orderList,
    //   edit: true,
    // });
  }

  const storedDataOnFirebase = async () => {
    let check = formCheckFunction();

    let nsn = questionName.replaceAll(" ", "");

    let dat = /\//i.test(nsn);

    if (!dat) {
    } else {
      alert("you can not use any (/) characters");
      return;
    }
    if (check != "alliswell") {
      setFormCheck("check");
      return;
    }

    setFormCheck("");
    let questionTypeEnum;
    let managequestionData;

    console.log(qus5);
    if (qustype == "8") {
      let questionDatafromUser = {
        options: qus5,
        question: qus,
        questionInstruction: qusInstruction,
      };
      managequestionData = questionDatafromUser;

      questionTypeEnum = 5;
    }

    let configCreateExtraInfo = {
      method: "post",
      // params: { questionSetId: quizId },
      url: `${IP}/courseBuilder/question`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: JSON.stringify({
        questionId: questionId,
        questionName: questionName,
        questionType: qustype,
        created: new Date(),
        questionData: managequestionData,
        questionPoolAssociated: quizId,
      }),
    };
    axios(configCreateExtraInfo).then((res) => {
      alert("data saved successfully");
      setfetchDataFromApi(fetchDataFromApi + 1);
    });

    toggleQuestionForm();

    document.getElementById(quizId + "question-form").reset();
    document.getElementById(quizId + "questionName").value = "";
  };

  const toggleQuestionForm = (e) => {
    resetData();
    document.getElementById(quizId + "questionForm").style.display =
      document.getElementById(quizId + "questionForm").style.display == "none"
        ? "block"
        : "none";
  };
  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(list);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setList(items);
    saveOrder(items);
  }

  function edit(lesson) {
    toggleQuestionForm();
  }

  function resetData() {
    setQuestionName("");
    setQuestionId("");
    setqustype("8");
    setqus("");
    setqusInstruction("");
    setRearrangeOptions([
      {
        text: "First",
        position: 1,
      },
      {
        text: "Second",
        position: 2,
      },
      {
        text: "Third",
        position: 3,
      },
      {
        text: "Fourth",
        position: 4,
      },
    ]);
    setqus5({
      option1: "",
      option2: "",
      option3: "",
      option4: "",
    });
    setqus5Answer("Option 1");
  }

  return (
    <section className="quizForm-container">
      <form id={quizId + "question-form"} onSubmit={submit}>
        <div className="quizForm-mainForm-infoRow">
          <p className="quizForm-mainForm-label">Question Name :</p>
          <input
            type="text"
            className="quizForm-mainForm-inputBar"
            value={questionName}
            id={quizId + "questionName"}
            style={{
              border: `${
                checkErrorInForm.questionName == "error"
                  ? "2px solid red"
                  : "1px solid #d7d7d7"
              }`,
            }}
            onChange={(e) => {
              setQuestionName(e.target.value);
              setCheckErrorInForm((prev) => ({ ...prev, questionName: "" }));
              let value = e.target.value.replaceAll(" ", "");
              let time = new Date().getTime();
              if (!editQuestion) {
                setQuestionId(value + "_" + time);
              }
            }}
          />

          {checkErrorInForm.questionName == "error" && (
            <span
              style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
            >
              Enter Question Name
            </span>
          )}
        </div>

        <div className="quizForm-mainForm-infoRow">
          <label className="quizForm-mainForm-label">Question : </label>
          <textarea
            className="quizForm-mainForm-textarea"
            value={qus}
            style={{
              border: `${
                checkErrorInForm.qus == "error"
                  ? "2px solid red"
                  : "1px solid #d7d7d7"
              }`,
            }}
            onChange={(event) => {
              setqus(event.target.value);
              setCheckErrorInForm((prev) => ({ ...prev, qus: "" }));
            }}
          ></textarea>

          {checkErrorInForm.qus == "error" && (
            <span
              style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
            >
              Enter Question
            </span>
          )}
        </div>
        <div className="quizForm-mainForm-infoRow">
          <label className="quizForm-mainForm-label">Instruction : </label>
          <textarea
            className="quizForm-mainForm-textarea"
            value={qusInstruction}
            style={{
              border: `${
                checkErrorInForm.qusInstruction == "error"
                  ? "2px solid red"
                  : "1px solid #d7d7d7"
              }`,
            }}
            onChange={(event) => {
              setqusInstruction(event.target.value);
              setCheckErrorInForm((prev) => ({ ...prev, qusInstruction: "" }));
            }}
          ></textarea>

          {checkErrorInForm.qusInstruction == "error" && (
            <span
              style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
            >
              Enter Question Instruction
            </span>
          )}
        </div>

        {qustype == "8" ? (
          <>
            <div className="quizForm-mainForm-infoRow">
              <label className="quizForm-mainForm-label">Option 1 : </label>
              <input
                className="quizForm-mainForm-inputBar"
                name="text"
                value={qus5.option1}
                placeholder="Enter Option"
                style={{
                  border: `${
                    checkErrorInForm.option1 == "error"
                      ? "2px solid red"
                      : "1px solid #d7d7d7"
                  }`,
                }}
                onChange={(event) => {
                  setqus5({ ...qus5, option1: event.target.value });
                  setCheckErrorInForm((prev) => ({ ...prev, option1: "" }));
                }}
              />
              {checkErrorInForm.option1 == "error" && (
                <span
                  style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
                >
                  Enter Question option1 min length 2 ,max length 8
                </span>
              )}
            </div>
            <div className="quizForm-mainForm-infoRow">
              <label className="quizForm-mainForm-label">Option 2 : </label>
              <input
                className="quizForm-mainForm-inputBar"
                name="text"
                value={qus5.option2}
                style={{
                  border: `${
                    checkErrorInForm.option2 == "error"
                      ? "2px solid red"
                      : "1px solid #d7d7d7"
                  }`,
                }}
                placeholder="Enter Option"
                onChange={(event) => {
                  setqus5({ ...qus5, option2: event.target.value });
                  setCheckErrorInForm((prev) => ({ ...prev, option2: "" }));
                }}
              />

              {checkErrorInForm.option2 == "error" && (
                <span
                  style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
                >
                  Enter Question option2 min length 2 ,max length 8
                </span>
              )}
            </div>
            <div className="quizForm-mainForm-infoRow">
              <label className="quizForm-mainForm-label">Option 3 : </label>
              <input
                className="quizForm-mainForm-inputBar"
                name="text"
                value={qus5.option3}
                style={{
                  border: `${
                    checkErrorInForm.option3 == "error"
                      ? "2px solid red"
                      : "1px solid #d7d7d7"
                  }`,
                }}
                placeholder="Enter Option"
                onChange={(event) => {
                  setqus5({ ...qus5, option3: event.target.value });
                  setCheckErrorInForm((prev) => ({ ...prev, option3: "" }));
                }}
              />

              {checkErrorInForm.option3 == "error" && (
                <span
                  style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
                >
                  Enter Question option3 min length 2 ,max length 8
                </span>
              )}
            </div>
            <div className="quizForm-mainForm-infoRow">
              <label className="quizForm-mainForm-label">Option 4 : </label>
              <input
                className="quizForm-mainForm-inputBar"
                type="text"
                value={qus5.option4}
                style={{
                  border: `${
                    checkErrorInForm.option4 == "error"
                      ? "2px solid red"
                      : "1px solid #d7d7d7"
                  }`,
                }}
                placeholder="Enter Option"
                onChange={(event) => {
                  setqus5({ ...qus5, option4: event.target.value });
                  setCheckErrorInForm((prev) => ({ ...prev, option4: "" }));
                }}
              />
              {checkErrorInForm.option4 == "error" && (
                <span
                  style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
                >
                  Enter Question option4 min length 2 ,max length 8
                </span>
              )}
            </div>

            <div className="quizForm-mainForm-infoRow">
              <label className="quizForm-mainForm-label">Option 5 : </label>
              <input
                className="quizForm-mainForm-inputBar"
                type="text"
                value={qus5.option5}
                style={{
                  border: `${
                    checkErrorInForm.option5 == "error"
                      ? "2px solid red"
                      : "1px solid #d7d7d7"
                  }`,
                }}
                placeholder="Enter Option"
                onChange={(event) => {
                  setqus5({ ...qus5, option5: event.target.value });
                  setCheckErrorInForm((prev) => ({ ...prev, option5: "" }));
                }}
              />
              {checkErrorInForm.option5 == "error" && (
                <span
                  style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
                >
                  Enter Question option5 min length 2 ,max length 8
                </span>
              )}
            </div>

            <div className="quizForm-mainForm-infoRow">
              <label className="quizForm-mainForm-label">Option 6 : </label>
              <input
                className="quizForm-mainForm-inputBar"
                type="text"
                value={qus5.option6}
                style={{
                  border: `${
                    checkErrorInForm.option6 == "error"
                      ? "2px solid red"
                      : "1px solid #d7d7d7"
                  }`,
                }}
                placeholder="Enter Option"
                onChange={(event) => {
                  setqus5({ ...qus5, option6: event.target.value });
                  setCheckErrorInForm((prev) => ({ ...prev, option6: "" }));
                }}
              />
              {checkErrorInForm.option6 == "error" && (
                <span
                  style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
                >
                  Enter Question option6 min length 2 ,max length 8
                </span>
              )}
            </div>
          </>
        ) : (
          " "
        )}
      </form>
      {formCheck && <div> Fill all the Required fields.</div>}
      <div className="quizForm-mainForm-infoRow">
        <button
          className="quizFrom-button"
          style={{ marginLeft: "auto" }}
          onClick={storedDataOnFirebase}
        >
          Submit
        </button>
      </div>
    </section>
  );
};

export default CreateCrossWordQuestion;
